import * as Sentry from '@sentry/react';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { IS_DEV, IS_PROD, IS_STAGING, ORN_ENV } from '../env';
import { getOptionalEnv } from '../lib/getEnv';
import MainApp from '../MainApp';
import ApolloProvider from '../providers/ApolloProvider';

import '../styles/app.css';

// Sentry init — gated on !IS_DEV and skipped entirely when no DSN is configured.
// A dedicated Sentry project for mops-web can be wired later by setting
// VITE_SENTRY_DSN_MOPS_WEB in the build env.
if (!IS_DEV) {
  const dsn = getOptionalEnv('VITE_SENTRY_DSN_MOPS_WEB');
  if (dsn) {
    const release = getOptionalEnv('VITE_SENTRY_RELEASE');
    Sentry.init({
      dsn,
      environment: ORN_ENV,
      release,
      sendDefaultPii: true,
      tracesSampleRate: 1.0,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
      ],
      replaysSessionSampleRate: IS_PROD ? 1.0 : 0,
      replaysOnErrorSampleRate: IS_PROD ? 1.0 : 0,
    });
  }
}

const bootstrap = () => {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <Helmet>
          <title>MOPS{IS_DEV ? ' Dev' : IS_STAGING ? ' Staging' : ''}</title>
        </Helmet>
        <ApolloProvider>
          <MainApp />
        </ApolloProvider>
      </HelmetProvider>
    </React.StrictMode>
  );
};

bootstrap();
